/* eslint func-names: [2, "never"] */
import $ from 'jquery';

const cleanHTML = (html) => {
    let rawHTML = `<div>${html}</div>`;
    rawHTML = $('<div>').append($(rawHTML));
    rawHTML.find('img').each(function () {
        if (!$(this).parent().is('figure')) {
            $(this).wrap('<figure>');
        }
    });
    rawHTML = rawHTML.clone().remove().html();
    return rawHTML;
};

export default cleanHTML;
